import { HttpInterceptors } from "./http.interceptor";

export class WhatsAppService extends HttpInterceptors {
	async connectWhatsApp () {
		const response = await this.axios.get("whatsApp/connectWhatsApp");
		return response.data;
	}

	async disconnectWhatsApp () {
		const response = await this.axios.get("whatsApp/disconnectWhatsApp");
		return response.data;
	}

	async sendMessage (payload) {
		const response = await this.axios.post("whatsApp/sendMessage", payload);
		return response.data;
	}

	async getStatusWhatsApp () {
		const response = await this.axios.get("whatsApp/getStatusWhatsApp");
		return response.data;
	}
}
